export const elementArgumentTemplate = ({
    key,
    value
}: {
    key: string
    value: string
}) => `$${key} = ${value}
`

